// frontend/src/pages/public/ForProviders/ForProvidersContent.ts

export const forProvidersHero = {
  eyebrow: "For Providers",
  title: "Built for real clinical workflows",
  subtitle:
    "AcceptingMD helps family doctors manage new patient intake more efficiently. No phone calls, guesswork, or unnecessary back-and-forth.",
};

export const forProvidersFeatures = {
  id: "features",
  title: "What You Can Do",
  subtitle: "Manage new patient intake on your terms",
  bullets: [
    "Receive new patient requests directly through your portal",
    "Invite patients for a Meet & Greet, place requests on a waitlist, or decline requests directly from the portal",
    "Turn accepting new patients on or off at any time",
    "Update clinic hours, services, and accessibility features",
    "Review standardized patient request information before making an intake decision",
    "Manage new patient intake from a simple dashboard",
  ],
};

export const forProvidersValueSummary = {
  id: "value",
  title: "Designed for real-world care delivery",
  bullets: [
    "Reduced administrative overhead. Clear information and structured intake reduce phone calls.",
    "Capacity-based and clinic-controlled. Family doctors make their own intake decisions based on their practice capacity, scope, and intake criteria.",
    "Not a ranking platform. AcceptingMD is a standardized patient intake and attachment workflow.",
  ],
};

export const forProvidersCtas = {
  title: "Ready to get started?",
  subtitle: "Sign in to access AcceptingMD, or contact us with questions.",
  primaryCta: { label: "Sign In", to: "/portal/login" },
  secondaryCta: { label: "How It Works", to: "/public/how-it-works" },
  contactCta: { label: "Contact Us", to: "/public/contact" },
};
